import { AlertOctagon } from 'lucide-react'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/Button'

export default function ServerError({ errorId }: { errorId?: string }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <div className="mx-auto max-w-lg py-20 text-center">
      <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-alert-tint">
        <AlertOctagon className="h-9 w-9 text-alert-text" />
      </div>
      <h1 className="text-2xl font-bold text-heading">{t('errors.somethingWentWrong')}</h1>
      <p className="mt-2 text-muted">{t('errors.notifiedLooking')}</p>
      {errorId ? <p className="mt-1 font-mono text-xs text-muted">Error ID: {errorId}</p> : null}
      <div className="mt-6 flex justify-center gap-3">
        <Button variant="secondary" onClick={() => navigate(0)}>{t('actions.tryAgain')}</Button>
        <Link to="/" className="inline-flex h-10 items-center rounded-input bg-green px-4 text-sm font-semibold text-white hover:bg-green-hover">
          {t('errors.goToDashboard')}
        </Link>
      </div>
    </div>
  )
}
